import pageTitle from 'ember-page-title/helpers/page-title';
import t from 'ember-intl/helpers/t';
import Root from 'frontend/components/school/root';
import set from 'ember-set-helper/helpers/set';
<template>
  {{pageTitle (t "general.schools")}}
  <Root
    @school={{@model}}
    @canUpdateSchool={{@controller.canUpdateSchool}}
    @canUpdateCompetency={{@controller.canUpdateCompetency}}
    @canDeleteCompetency={{@controller.canDeleteCompetency}}
    @canCreateCompetency={{@controller.canCreateCompetency}}
    @canUpdateVocabulary={{@controller.canUpdateVocabulary}}
    @canDeleteVocabulary={{@controller.canDeleteVocabulary}}
    @canCreateVocabulary={{@controller.canCreateVocabulary}}
    @canUpdateTerm={{@controller.canUpdateTerm}}
    @canDeleteTerm={{@controller.canDeleteTerm}}
    @canCreateTerm={{@controller.canCreateTerm}}
    @canUpdateSessionType={{@controller.canUpdateSessionType}}
    @canDeleteSessionType={{@controller.canDeleteSessionType}}
    @canCreateSessionType={{@controller.canCreateSessionType}}
    @canUpdateSchoolConfig={{@controller.canUpdateSchoolConfig}}
    @schoolCompetencyDetails={{@controller.schoolCompetencyDetails}}
    @setSchoolCompetencyDetails={{set @controller "schoolCompetencyDetails"}}
    @schoolManageCompetencies={{@controller.schoolManageCompetencies}}
    @setSchoolManageCompetencies={{set @controller "schoolManageCompetencies"}}
    @schoolMapCompetencies={{@controller.schoolMapCompetencies}}
    @setSchoolMapCompetencies={{set @controller "schoolMapCompetencies"}}
    @schoolVocabularyDetails={{@controller.schoolVocabularyDetails}}
    @setSchoolVocabularyDetails={{set @controller "schoolVocabularyDetails"}}
    @schoolManagedVocabulary={{@controller.schoolManagedVocabulary}}
    @setSchoolManagedVocabulary={{set @controller "schoolManagedVocabulary"}}
    @schoolManagedVocabularyTerm={{@controller.schoolManagedVocabularyTerm}}
    @setSchoolManagedVocabularyTerm={{set @controller "schoolManagedVocabularyTerm"}}
    @schoolLeadershipDetails={{@controller.schoolLeadershipDetails}}
    @setSchoolLeadershipDetails={{set @controller "schoolLeadershipDetails"}}
    @schoolManageLeadership={{@controller.schoolManageLeadership}}
    @setSchoolManageLeadership={{set @controller "schoolManageLeadership"}}
    @schoolSessionAttributesDetails={{@controller.schoolSessionAttributesDetails}}
    @setSchoolSessionAttributesDetails={{set @controller "schoolSessionAttributesDetails"}}
    @schoolManageSessionAttributes={{@controller.schoolManageSessionAttributes}}
    @setSchoolManageSessionAttributes={{set @controller "schoolManageSessionAttributes"}}
    @schoolLearningMaterialAttributesDetails={{@controller.schoolLearningMaterialAttributesDetails}}
    @setSchoolLearningMaterialAttributesDetails={{set
      @controller
      "schoolLearningMaterialAttributesDetails"
    }}
    @schoolManageLearningMaterialAttributes={{@controller.schoolManageLearningMaterialAttributes}}
    @setSchoolManageLearningMaterialAttributes={{set
      @controller
      "schoolManageLearningMaterialAttributes"
    }}
    @schoolSessionTypeDetails={{@controller.schoolSessionTypeDetails}}
    @setSchoolSessionTypeDetails={{set @controller "schoolSessionTypeDetails"}}
    @schoolManagedSessionType={{@controller.schoolManagedSessionType}}
    @setSchoolManagedSessionType={{set @controller "schoolManagedSessionType"}}
    @schoolNewSessionType={{@controller.schoolNewSessionType}}
    @setSchoolNewSessionType={{set @controller "schoolNewSessionType"}}
    @schoolManageInstitutionalInformation={{@controller.schoolManageInstitutionalInformation}}
    @setSchoolManageInstitutionalInformation={{set
      @controller
      "schoolManageInstitutionalInformation"
    }}
    @schoolNewVocabulary={{@controller.schoolNewVocabulary}}
    @setSchoolNewVocabulary={{set @controller "schoolNewVocabulary"}}
    @schoolManageEmails={{@controller.schoolManageEmails}}
    @setSchoolManageEmails={{set @controller "schoolManageEmails"}}
  />
</template>
